import { render, staticRenderFns } from "./appUsersPushNotificationsHistory.vue?vue&type=template&id=654c1f1c&"
import script from "./appUsersPushNotificationsHistory.vue?vue&type=script&lang=js&"
export * from "./appUsersPushNotificationsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports